// jQuery
import $ from "jquery";

// Bootstrap
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';

// Lazysizes
import lazySizes from 'lazysizes';

// Lightbox
import GLightbox from 'glightbox';
const lightbox = GLightbox({
    loop: true,
});

// Custom
import './custom/megamenu';

// AOS
// import AOS from 'aos';

// Plyr
import Plyr from 'plyr';
const players = Plyr.setup('.video-player', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        noCookie: false,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    }
});

// Swiper
import Swiper, {
    Navigation,
    Pagination,
    Autoplay
} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

var visual = new Swiper('.homepage-visual .slider.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: $('.swiper-slide').length > 1 ? true : false,
    autoplay: $('.swiper-slide').length > 1 ? true : false,
    autoplay: {
        delay: 5000,
    },
    pagination: {
        el: '.visual-pagination',
        clickable: true
    },
    watchOverflow: true
});

var slider = new Swiper('.product-benefits .slider.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
    }
});

var gallery = new Swiper('.content-gallery .slider.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
        nextEl: '.gallery-next',
        prevEl: '.gallery-prev',
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    watchOverflow: true
});

gallery.on('slideChange', function() {
    players.forEach(function(player) {
        player.pause();
    });
});

// AOS.init({
//   delay: 300
// });

// jQuery Functions

$(document).ready(function() {
    $('body').addClass('woof');

        // behavior for sub menus
    $('.megamenu a[data-toggle="tab"]').hover(function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).tab('show');
    });
    $('.megamenu a[data-toggle="tab"]').click(function(e) {
        window.location.href = $(this).attr("href");
    });
});

// Conditional JS for large screens

document.addEventListener("DOMContentLoaded", function() {
    console.log('A DIGITAL PROJECT BY\n\r······································································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo······················oooo·······································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo····oooooo············oooo······oooooooooooooooo·········ooooooooo···············oooooooooo······\n\r·oooooooooooooooooo········oooo·····ooooooooooooooooo······ooooooooooooooo·········oooooooooooooooo···\n\r·oooooooo······ooooo·······oooo················ooooo·····ooooo·········ooooo·····ooooo··········ooooo·\n\r·ooooo···········ooooo·····oooo··············ooooo······ooooo···········ooooo····ooo·············oooo·\n\r·oooo·············oooo·····oooo·············ooooo·······ooooooooooooooooooooo···oooo··············ooo·\n\r·oooo·············oooo·····oooo···········ooooo·········oooo····················oooo··············ooo·\n\r·oooo·············oooo·····oooo··········oooo···········oooo····················oooo··············ooo·\n\r··ooooo·········ooooo······oooo········ooooo·············oooo···········oooo····oooo··············ooo·\n\r····oooooooooooooooo·······oooo······ooooooooooooooo······oooooo······ooooo·····oooo··············ooo·\n\r·······oooooooooo··········oooo·····ooooooooooooooooo········oooooooooooo·······oooo··············ooo·\n\r······································································································\n\r');
});